import React from "react";
import { Stack, Typography } from "@mui/material";
import colors from "../../utils/colors";

const AccessDenied = ({ resource = "this resource" }) => {
  return (
    <Stack alignItems="center" justifyContent="center" spacing={2} sx={{ minHeight: "400px" }}>
      <Typography sx={ { fontSize: 20, fontWeight: "medium", color: colors.neutral[1000] }}>
        Access Denied
      </Typography>
      <Typography sx={ { fontSize: 16, color: colors.neutral[700], textAlign: "center" }}>
        You don't have permission to view {resource}.
      </Typography>
      <Typography sx={ { fontSize: 14, color: colors.neutral[600], textAlign: "center" }}>
        Please contact your administrator to request access.
      </Typography>
    </Stack>
  );
};

export default AccessDenied;